import { defineNuxtPlugin } from '#imports'
import { useAuthStore } from '~/stores/useAuthStore'
import { useUIStore } from '~/stores/useUIStore'

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia

  const authStore = useAuthStore(pinia)
  const uiStore = useUIStore(pinia)

  const authCookie = useCookie('auth', { maxAge: 365 * 24 * 60 * 60, secure: false })

  // Read persisted state from cookie (same format as vuex-persistedstate used)
  const raw = authCookie.value

  if (raw) {
    try {
      const data = typeof raw === 'string' ? JSON.parse(raw) : raw

      // Hydrate auth store
      if (data.auth?.active != null) authStore.active = data.auth.active
      if (data.auth?.guids) authStore.guids = data.auth.guids

      // Hydrate UI store
      if (data.menu != null) uiStore.menu = data.menu
      if (data.sidebar != null) uiStore.sidebar = data.sidebar
      if (data.theme != null) uiStore.setTheme(data.theme)
      if (data.alerts?.filter != null) uiStore.setAlerts({ key: 'filter', value: data.alerts.filter })
      if (data.dashboard?.showPastReservations != null) uiStore.setDashboard({ key: 'showPastReservations', value: data.dashboard.showPastReservations })
      if (data.schedule?.sectionSize != null) uiStore.setSchedule({ key: 'sectionSize', value: data.schedule.sectionSize })
      if (data.schedule?.showResources != null) uiStore.setSchedule({ key: 'showResources', value: data.schedule.showResources })
      if (data.order?.print != null) uiStore.setOrder({ key: 'print', value: data.order.print })
    } catch (e) {
      // Invalid cookie data — ignore
    }
  }

  // Persist changes back to cookie (client only)
  if (import.meta.client) {
    const persist = () => {
      const data = {
        menu: uiStore.menu,
        sidebar: uiStore.sidebar,
        theme: uiStore.theme,
        alerts: { filter: uiStore.alerts.filter },
        dashboard: { showPastReservations: uiStore.dashboard.showPastReservations },
        auth: { active: authStore.active, guids: authStore.guids },
        schedule: { sectionSize: uiStore.schedule.sectionSize, showResources: uiStore.schedule.showResources },
        order: { print: uiStore.order.print },
      }
      authCookie.value = data
    }

    authStore.$subscribe(persist)
    uiStore.$subscribe(persist)
  }
})
